import type { WModuleGroupViewList } from '@zola/svc-web-api-ts-client';

export const REQUEST_MODULE_GROUP = 'zola/moduleGroups/REQUEST_MODULE_GROUP';
export const RECEIVE_MODULE_GROUP = 'zola/moduleGroups/RECEIVE_MODULE_GROUP';

type RequestModuleGroupsActionType = {
  type: typeof REQUEST_MODULE_GROUP;
};

type ReceiveModuleGroupsActionType = {
  type: typeof RECEIVE_MODULE_GROUP;
  payload: WModuleGroupViewList;
};

export type ModuleGroupActionTypes = RequestModuleGroupsActionType | ReceiveModuleGroupsActionType;
